<template>
    <b-modal v-model="modal_propiedades.ver"
             size="xl"
             title="Propiedades de producto"
             hide-footer
    >
        <form @submit.prevent="validarFormulario()"
              data-vv-scope="propiedades"
        >
            <!-- SECCIÓN DE PROPIEDADES FÍSICAS -->
            <b-card class="contenedor">
                <div slot="header"
                     class="text-center font-weight-bold"
                >
                    PROPIEDADES FÍSICAS
                </div>
                <div class="row">
                    <!-- Peso molecular -->
                    <div class="form-group col-md-4">
                        <label for="peso_molecular">
                            Peso molecular
                            <span class="text-primary"
                                  v-text="'g/mol'"
                            />
                        </label>
                        <b-form-input id="peso_molecular"
                                      name="peso_molecular"
                                      type="number"
                                      step="0.001"
                                      v-model="propiedades.peso_molecular"
                                      class="form-input-group"
                                      data-vv-as=" "
                                      v-validate="'decimal:3'"
                        />
                        <div class="text-danger span-error small"
                             v-text="errors.first('propiedades.peso_molecular')"
                        />
                        <el-tooltip
                            v-if="flagSaveProperties"
                            effect="dark"
                            placement="top"
                            content="Ver ficha de seguridad"
                            popper-class="py-1 px-2"
                            class="mt-2"
                        >
                         <b-button
                            variant="warning"
                            class="float-right px-3"
                            size="sm"
                            @click="obtainSafetyDataSheets(tarea.id_producto)"
                            :disabled="!tarea.id_producto"
                          >
                            <i class="fa fa-file-text-o" aria-hidden="true"></i>
                         </b-button>
                        </el-tooltip>
                        <div v-if="flagSaveProperties" class="text-danger span-error mr-5">
                            Para realizar la conversión del TLV se requiere el peso molecular obligatorio, debe ser diferente a cero.
                        </div>

                    </div>

                    <!-- Punto de ebullición -->
                    <div class="form-group col-md-4">
                        <label for="id_um_punto_ebullicion"
                               class="w-100"
                        >
                            Punto de ebullición
                            <b-form-checkbox v-model="propiedades.punto_ebullicion_rango"
                                             class="float-right"
                                             v-b-tooltip.top.hover="'Rango de valores'"
                                             :value="1"
                                             :unchecked-value="0"
                            />
                        </label>
                        <b-row>
                            <b-col :class="propiedades.punto_ebullicion_rango ? 'pr-0' : ''">
                                <b-form-input id="punto_ebullicion"
                                              name="punto_ebullicion"
                                              type="number"
                                              step="0.001"
                                              v-model="propiedades.punto_ebullicion"
                                              data-vv-as=" "
                                              v-validate="{
                                                    rules: {
                                                        required: !!propiedades.punto_ebullicion_rango,
                                                        decimal: 3,
                                                    }
                                              }"
                                />
                                <div class="text-danger span-error small"
                                     v-text="errors.first('propiedades.punto_ebullicion')"
                                />
                            </b-col>

                            <b-col cols="1"
                                   v-if="propiedades.punto_ebullicion_rango"
                                   class="font-weight-bold text-center pt-2"
                            >
                                -
                            </b-col>

                            <b-col v-if="propiedades.punto_ebullicion_rango"
                                   class="pl-0"
                            >
                                <b-form-input id="punto_ebullicion_hasta"
                                              name="punto_ebullicion_hasta"
                                              type="number"
                                              step="0.001"
                                              v-model="propiedades.punto_ebullicion_hasta"
                                              :disabled="!propiedades.punto_ebullicion"
                                              data-vv-as=" "
                                              v-validate="{
                                    rules: {
                                        required: !!propiedades.punto_ebullicion_rango,
                                        decimal: 3,
                                        min_value: ![null, ''].includes(propiedades.punto_ebullicion) ? (+propiedades.punto_ebullicion +0.001) : 0,
                                        max_value: 999
                                    }
                                }"
                                />

                                <div class="text-danger span-error small"
                                     v-text="errors.first('propiedades.punto_ebullicion_hasta')"
                                />
                            </b-col>

                            <b-col>
                                <el-select id="id_um_punto_ebullicion"
                                           name="id_um_punto_ebullicion"
                                           v-model="propiedades.id_um_punto_ebullicion"
                                           placeholder=" "
                                           :disabled="(propiedades.punto_ebullicion_rango && ([null, ''].includes(propiedades.punto_ebullicion) || [null, ''].includes(propiedades.punto_ebullicion_hasta))) || (!propiedades.punto_ebullicion_rango && [null, ''].includes(propiedades.punto_ebullicion))"
                                           size="small"
                                           data-vv-as=" "
                                           v-validate="{
                                            rules: {
                                                required: !!propiedades.punto_ebullicion_rango
                                            }
                                        }"
                                >
                                    <el-option v-for="item in unidades_de_temperatura"
                                               :key="item.id"
                                               :label="item.lista"
                                               :value="item.id"
                                    />
                                </el-select>
                                <div class="text-danger span-error small"
                                     v-text="errors.first('propiedades.id_um_punto_ebullicion')"
                                />
                            </b-col>
                        </b-row>
                    </div>
                </div>
            </b-card>

            <!-- BOTÓN GUARDAR -->
            <div class="row">
                <div class="col-12 text-center">
                    <button class="btn btn-sm btn-primary">
                        <i class="fa fa-save"></i> Guardar
                    </button>
                </div>
            </div>
        </form>
    </b-modal>
</template>

<script>
import {mapActions, mapMutations, mapState} from 'vuex';

export default {
    name: 'modal_propiedades',
    props: {
        validationMolecularWeight: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        ...mapState('analysis', [
            'propiedades',
            'modal_propiedades',
            'unidades_de_temperatura',
            'tarea'
        ])
    },
    data() {
        return {
            flagSaveProperties: false
        };
    },
    mounted() {
        this.checkMolecularWeight();
    },
    watch: {
        'modal_propiedades.ver'(val) {
            if (val) {
                this.checkMolecularWeight();
            }
        }
    },
    methods: {
        ...mapMutations('analysis', [
            'setDefaultPropiedades'
        ]),
        ...mapActions('analysis', [
            'guardarPropiedades',
            'obtenerPropiedades',
            'obtenerUnidadesDeTemperatura'
        ]),
        ...mapActions('productos', ['obtainSafetyDataSheets']),
        validarFormulario() {
            this.$validator.validateAll('propiedades').then((result) => {
                if (result) {
                    this.guardarPropiedades(this.tarea.id_producto);
                    if (
                        this.propiedades.peso_molecular !== null &&
                        this.propiedades.peso_molecular !== '' &&
                        Number(this.propiedades.peso_molecular) !== 0
                    ) {
                        this.flagSaveProperties = false;
                        this.$emit('flag-save-properties', true);
                    } else {
                        if(this.validationMolecularWeight) {
                            this.flagSaveProperties = true;
                        }else{
                            this.flagSaveProperties = false;
                        }
                        this.$emit('flag-save-properties', false);
                        this.$emit('update:validationMolecularWeight', true);
                    }
                }
            });
        },
        checkMolecularWeight() {
            if (this.validationMolecularWeight) {
                this.flagSaveProperties = this.validationMolecularWeight;
            }else {
                this.flagSaveProperties = false;
            }
        },
    }
};
</script>

<style>
.form-input-group {
    height: 32px !important;
}
</style>
